// Mismos valores que TIPOS_ADMIN de la API (admin.schema.ts)
export const ADMIN_GENERAL = '0';

export const TIPOS_ADMIN = [
    { valor: '0', etiqueta: 'Administrador General' },
    { valor: '1', etiqueta: 'Administrador de Cursos' },
    { valor: '2', etiqueta: 'Administrador de Multimedia' },
    { valor: '3', etiqueta: 'Administrador de Inscripciones y Reinscripciones' },
    { valor: '4', etiqueta: 'Administrador de Alumnos' },
    { valor: '5', etiqueta: 'Administrador de Finanzas' }
];

export const etiquetaTipo = tipo => TIPOS_ADMIN.find(({ valor }) => valor === String(tipo))?.etiqueta ?? 'Administrador';
